import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@orion/environment';
import { firstValueFrom } from 'rxjs';
import { CONFIGURATION_PATH } from './config.consts';
import { AppConfig } from './config.types';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly http = inject(HttpClient);
  private appConfigData!: AppConfig;

  async loadConfig(): Promise<AppConfig | null> {
    try {
      this.appConfigData = await firstValueFrom(
        this.http.get<AppConfig>(`${CONFIGURATION_PATH}config.${environment.name}.json`),
      );
      console.log('Configuration loaded', this.appConfigData);
      return this.appConfigData;
    } catch (error) {
      console.error('Could not load configuration', error);
      return null;
    }
  }

  getSettings<K extends keyof AppConfig>(
    key?: K,
    defaultValue?: AppConfig[K],
  ): AppConfig | AppConfig[K] | undefined {
    if (!this.appConfigData) {
      console.warn('[ConfigService] Configuration not loaded yet.');
      return defaultValue;
    }

    if (!key) {
      return this.appConfigData;
    }

    const value = this.appConfigData[key];
    if (value === undefined) {
      console.warn(`[ConfigService] Key "${String(key)}" not found in configuration.`);
      return defaultValue;
    }

    return value;
  }
}
